export const AUTH_FORM_TEXT = "Войдите или зарегистрируйтесь, чтобы увидеть контакты продавца";